import { BidDTO } from "./bidDTO";

export class AuctionBidAdminDTO extends BidDTO{
    public userId!:string;
    public userName!:string;
    public firstName!:string;
    public lastName!:string;
    public role!:string;
    public bidAmount!:number;
    public proxyBid:boolean = false;
    public equalized:boolean = false;
    public equalizedReason?:string;
    public representingBrokerId?:number;
    public proxyBidHistory?:string;
    public voidReason?:string;
    public voidIndex?:number;
}